
import { defineComponent, PropType, toRefs } from 'vue';
import { Client } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';
import { useRouter } from 'vue-router';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';

export default defineComponent({
  name: 'ClientsTable',
  components: {
    AppTable,
    Timestamp,
    MaterialIcon,
    MaterialIconButton
  },
  props: {
    clients: {
      type: Array as PropType<Array<Client>>,
      default: () => []
    }
  },
  setup(props) {
    const { clients } = toRefs(props);
    const { sortedData: sortedClients, sortBy, getSortState } = useTableSorting(clients, 'name');
    const router = useRouter();

    const navigateToBids = (client: Client) => router.push({ path: '/bids', query: { q: client.name } });

    return {
      sortedClients,
      sortBy,
      getSortState,
      navigateToBids
    };
  }
});
